import { TransitionGroup } from 'react-transition-group';
import { RemoveScroll } from 'react-remove-scroll';
import {
    EnterFrom,
    EnterFade,
} from 'tradera/components/transitions/transitions';
import { Overlay } from 'tradera/components/scrollable-modal/overlay';
import styles from './side-menu.module.scss';

type SideMenuProps = {
    children: React.ReactNode;
    fromLeft?: boolean;
    show: boolean;
    onDismiss: () => void;
    allowFullScreen?: boolean;
    width?: string;
};

export const SideMenu = ({
    children,
    fromLeft = false,
    show,
    onDismiss,
    allowFullScreen = false,
    width = '35rem',
}: SideMenuProps) => (
    <TransitionGroup component={null} mountOnEnter>
        {show && (
            <EnterFade in={show}>
                <Overlay
                    style={{
                        zIndex: 300,
                        top: '0',
                        height: '100vh',
                    }}
                    closeModalCallback={onDismiss}
                />
            </EnterFade>
        )}
        {show && (
            <EnterFrom from={fromLeft ? 'left' : 'right'} in={show}>
                <RemoveScroll forwardProps>
                    <div
                        className={
                            fromLeft
                                ? styles.sideMenu
                                : `${styles.sideMenu} ${styles.sideMenuFromRight}`
                        }
                        style={{
                            width: width,
                            maxWidth: allowFullScreen ? '100vw' : '90vw',
                        }}>
                        {children}
                    </div>
                </RemoveScroll>
            </EnterFrom>
        )}
    </TransitionGroup>
);
